import { useSelector } from "react-redux";
import EmptyState from "../../components/NoData/EmptyState";
import { Container } from "@jds/core";

const JitoUserLandingPage = () => {
  const { eventNotFoundJitoUser } = useSelector((state) => state.modal);

  return (
    <>
      {eventNotFoundJitoUser && (
        <Container paddingTop={180} fullWidth>
          <EmptyState
            title={`Event Not Found`}
            subtitle={"Please Try Again"}
            action={false}
          />
        </Container>
      )}
    </>
  );
};
export default JitoUserLandingPage;
